<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Result Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="staff.formatName(true, true)" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
          <template #post_buttons>
            <button
              v-show="checkPermission('delete staff')"
              title="Delete staff"
              class="btn btn-danger ml-1"
              @click="showDeleteModal"
            >
              <i class="fal fa-trash" />
            </button>
          </template>
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'read staff'">
      <template #gated-content>
        <staff-card :staff="staff" />
        <div v-if="staff.analyses">
          <h3>Analyses</h3>
          <analysis-table
            :analyses="staff.analyses"
            :show_columns="[
              'name',
              'modus_name',
              'extraction_method',
              'measurement_method',
            ]"
          />
        </div>
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import AnalysisTable from "@/components/lab/analysis/AnalysisTable";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import StaffCard from "@/components/lab/staff/StaffCard";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { notificationOptions } from "@/shared/toast-notification-options";
import { staffNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";

Vue.use(VueNotifications, notificationOptions);

const StaffRepository = LabRepositoryFactory.get("staff");

export default {
  name: "StaffDetail",
  components: {
    AnalysisTable,
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    StaffCard,
  },
  data() {
    return {
      loading: true,
      staff_id: this.$route.params.staff_id || null,
      staff: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/staff",
            title: "Staff list",
          },
          {
            icon: "fa-pencil",
            linkto: `/staff/${this.staff_id}/edit`,
            title: "Edit staff",
            variant: "warning",
            permission: this.checkPermission("edit staff"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    showDeleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this staff. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true,
          }
        )
        .then(async (confirm) => {
          if (confirm) {
            try {
              await StaffRepository.suspend(this.staff);

              this.deleteSuccess();
              this.$router.push("/staff");
            } catch ({ response }) {
              const { status, data } = response.response;

              this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
                title: "Server Error.",
                variant: "danger",
              });
            }
          }
        });
    },
  },
  async created() {
    this.loading = true;

    this.staff = await getModel({
      model_type: "staff",
      id: this.staff_id,
      message: this.$bvToast,
    });

    this.staff ? (this.loading = false) : this.$router.back();
  },
  notifications: staffNotifications,
};
</script>
